import { render, staticRenderFns } from "./TrainOnboardingTopCard.vue?vue&type=template&id=6dcbc91f&scoped=true"
import script from "./TrainOnboardingTopCard.vue?vue&type=script&lang=ts"
export * from "./TrainOnboardingTopCard.vue?vue&type=script&lang=ts"
import style0 from "./TrainOnboardingTopCard.vue?vue&type=style&index=0&id=6dcbc91f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcbc91f",
  null
  
)

export default component.exports